/* ─────────────────────────────────────────────────────────────────────────────
   BDZ: PDP Price Formatting
   • Strips trailing .00 from whole-dollar prices
   • Wraps the currency code in .price-currency (styled smaller in product-custom.css)
   • Re-runs after variant changes (variants.js replaces #price-{id} innerHTML)
───────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  function formatPriceEl(el) {
    if (el.querySelector('.price-currency')) return; // already processed
    if (!el.textContent.trim()) return;              // empty compare-at, skip

    var html = el.innerHTML;

    // Step 1: strip .00 before a currency code  e.g. "$2,637.00 NZD" → "$2,637 NZD"
    html = html.replace(/\.00(\s+(?:NZD|AUD|USD|GBP|EUR))/g, '$1');
    // Step 2: strip .00 at end of string, in case there's no currency suffix
    html = html.replace(/\.00\s*$/, '');
    // Step 3: wrap the currency code — absorb preceding whitespace so the
    //         span contains just the code, and one clean space sits outside it
    html = html.replace(/\s+(NZD|AUD|USD|GBP|EUR)\b/g, ' <span class="price-currency">$1</span>');

    el.innerHTML = html;
  }

  function formatPdpPriceBlock(container) {
    container.querySelectorAll('.price-item').forEach(formatPriceEl);
  }

  function initPdpPrice() {
    var priceBlock = document.querySelector('.wt-product__price');
    if (!priceBlock) return;

    formatPdpPriceBlock(priceBlock);

    // variants.js replaces priceBlock's direct children on variant change
    // (destination.innerHTML = source.innerHTML). childList:true / subtree:false
    // catches that without re-triggering on our own .price-item innerHTML writes.
    new MutationObserver(function () {
      formatPdpPriceBlock(priceBlock);
    }).observe(priceBlock, { childList: true, subtree: false });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpPrice);
  } else {
    initPdpPrice();
  }
})();